import React, { createContext, useContext, useState, useEffect } from 'react';
import translations from '../i18n/translations';

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(() => {
    return localStorage.getItem('cms_lang') || 'en';
  });

  const setLanguage = (lang) => {
    const validLang = lang === 'mr' ? 'mr' : 'en';
    setLanguageState(validLang);
    localStorage.setItem('cms_lang', validLang);
  };

  useEffect(() => {
    if (language === 'mr') {
      document.body.classList.add('lang-mr');
      document.documentElement.lang = 'mr';
    } else {
      document.body.classList.remove('lang-mr');
      document.documentElement.lang = 'en';
    }
  }, [language]);

  const t = (key, fallback = '') => {
    if (!key) return fallback;
    const langDict = translations[language] || translations.en;
    if (langDict && langDict[key] !== undefined) {
      return langDict[key];
    }
    // Fallback to English dictionary if key missing in Marathi
    if (translations.en && translations.en[key] !== undefined) {
      return translations.en[key];
    }
    return fallback || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
